
function ShowBsModal($modal) {
    $modal
        .off('shown.bs.modal')
        .on('shown.bs.modal', function() {
            window.scroll(0,0);
        });

    $modal.modal();
}

AddPageSwapTrigger(function () {
    var modalHash = '';
    var niceHashes = [
        '#start',
        '#open',
        '#verify',
        '#verifieer',
        '#verify',
        '#uberprufen',
        '#ueberpruefen',
        '#student',
        '#studentenkorting',
        '#studentenrabatt',
        '#studentdiscount',
        '#aanvragen',
        '#anfordern',
        '#apply',
		'#demand',
		'#demande',
		'#demander',
		'#solicitar',
		'#richiesta',
		'#zadanie',
        '#request'
    ];

    function noNewsletterNeeded() {
        return !$('.jsControleClosedModal').is('.jsControleClosedModal');
    }

    if(window.location.hash.indexOf("modalCoupon") !== -1) {
        modalHash = window.location.hash;
    }
    else if(niceHashes.includes(window.location.hash)) {
        modalHash = '#' + $('[id*=modalCoupon]:first').attr('id');
    }

    if (modalHash.length > 0 && (isSubscribedToNewsletter() || noNewsletterNeeded())) {
        var $modal = $(modalHash);
        if($modal.text().trim().length > 0) {
            ShowBsModal($modal);
        }
        else {
            var providerKey = $modal.find('input[name=providerKey]').val();
            var shopId = $modal.find('input[name=shopId]').val();
            var shopName = $modal.find('input[name=shopName]').val();
            var shopLogo = $modal.find('input[name=shopLogo]').val();
            var link = $modal.find('input[name=link]').val();
            var depleted = $modal.find('input[name=depleted]').val();
            var isUrl = $modal.find('input[name=isUrl]').val();

            var modalContent = generateBsModalVerification(providerKey, shopId, shopLogo, shopName, link, depleted, isUrl);
            $modal.html(modalContent);
            ShowBsModal($modal);
        }
    }
});
